export default {
  title: 'Anmeldung',

  namePH: 'Name',
  nameTaken: 'Dieser Name ist bereits vergeben',
  nameErr: 'Dein Name darf nur aus Buchstaben und Zahlen bestehen',

  emailPH: 'Email',
  emailTaken: 'Diese Email ist bereits vergeben',
  emailErr: 'Diese Email ist ungültig',

  pwd1PH: 'Passwort',
  pwd2PH: 'Passwort wiederholen',
  pwdErr: 'Die Passwörter müssen übereinstimmen',

  profilePic: 'Foto',

  formErr: 'Bitte korrigiere zuerst Deine Eingaben',
  submit: 'Speichern',
  busy: 'Bitte Warten',
  success: 'Deine Anmeldung war erfolgreich! Hier gehts weiter zum Login',
  fail: 'Da ist etwas schiefgelaufen - bitte versuch es später nochmal'
}



// WEBPACK FOOTER //
// ./src/i18n/register/de.js